import TomSelect from '@modules/tom-select';

/**
 * Inizializza l'input con formattazione numerica live.
 * @param {HTMLInputElement} inputElement - L'elemento input su cui applicare la formattazione.
 */
export function initFormattedInput(inputElement) {
    if (!inputElement) return;

    inputElement.addEventListener("input", function (e) {
        let input = e.target;
        let cursorPos = input.selectionStart;
        let rawValue = input.value.replace(/\D/g, "");
        let formatted = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        let diff = formatted.length - input.value.length;
        input.value = formatted;
        input.setSelectionRange(cursorPos + diff, cursorPos + diff);
    });
}

/**
 * Applica la formattazione numerica italiana a tutti gli elementi con classe `.formatNumb`.
 */
export function formatNumbers() {
    document.querySelectorAll(".formatNumb").forEach(el => {
        let text = el.textContent.trim().replace(/\./g, '').replace(',', '.');
        let number = parseFloat(text);
        if (!isNaN(number)) {
            el.textContent = number.toLocaleString("it-IT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
    });
}

/**
 * Inizializza tutti i dropdown con classe `.tomselect-dropdown` usando TomSelect.
 */
export function initDropdowns() {
    document.querySelectorAll(".tomselect-dropdown").forEach(el => {
        if (!el.tomselect) {
            const select = new TomSelect(el, {
                placeholder: el.getAttribute("data-placeholder"),
                create: true,
                hideSelected: true,
                accessibility: true,
            });
    
            // Imposta l'input come readonly
            select.control_input.setAttribute('readonly', true);
             // --- Gestione tastiera ---
            select.control_input.addEventListener("keydown", (e) => {
                console.log(e.key);
                switch (e.key) {
                    case "ArrowDown":
                    e.preventDefault();
                    select.open();
                    select.advanceSelection(1);

                    // Evidenzia opzione attiva
                    if (select.activeOption) {
                        console.log(select.activeOption);
                        select.dropdown.querySelectorAll(".option").forEach(opt => {
                           opt.style.setProperty("color", "", "important");
                            opt.style.setProperty("background-color", "", "important");
                        });
                       select.activeOption.style.setProperty("background-color", "#323232", "important");
                        select.activeOption.style.setProperty("color", "white", "important");
                    }

                    break;

                case "ArrowUp":
                    e.preventDefault();
                    select.open();
                    select.advanceSelection(-1);

                    // Evidenzia opzione attiva
                    if (select.activeOption) {
                        select.dropdown.querySelectorAll(".option").forEach(opt => {
                            opt.style.setProperty("background-color", "", "important");
                            opt.style.setProperty("color", "", "important");
                        });
                        select.activeOption.style.setProperty("background-color", "#323232", "important");
                        select.activeOption.style.setProperty("color", "white", "important");
                    }
                    break;

                    case "Enter":
                        e.preventDefault();
                        if (select.activeOption) {
                            select.addItem(select.activeOption.dataset.value);
                            select.close();
                        }
                        break;

                    case "Escape":
                        e.preventDefault();
                        select.close();
                        break;
                }
            });
        }
    });
}
export function TextAreaString() {
     var modalBody = document.getElementById("wee");

    if (modalBody) {
        let labels = modalBody.querySelectorAll("label");

        labels.forEach(function (label) {
            if (label.textContent.trim().includes("Messaggio") || label.textContent.trim().includes("Text")) {
                let wrapper = label.parentElement;
                let textarea = wrapper.querySelector("textarea");

                if (textarea) {
                    let divInfoContent = document.getElementById("Info").textContent.trim()
                        .replace(/\s*\n\s*/g, "\n");
                      

                    textarea.value = divInfoContent;
                }
            }
            
        })
    }
}
    